var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-input',{attrs:{"value":_vm.value,"rules":_vm.rules,"hide-details":_vm.hideDetails}},[_c('vue-tel-input',{staticClass:"w-100",attrs:{"value":_vm.inputValue,"valid-characters-only":"","ignored-countries":['PS'],"input-options":{
      placeholder: _vm.placeholder,
      styleClasses: 'phone-input w-100',
      autocomplete: 'on',
    }},on:{"focus":function($event){return _vm.$emit('focus')},"input":_vm.onInput},scopedSlots:_vm._u([{key:"arrow-icon",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-down")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }